import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";
import loginImg from "../assets/AccessAccount.png";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const text = "Welcome AAPS";

  return (
    <div className="login-main">
      <div className="login-image-side">
        <img src={loginImg} alt="Login" />
      </div>

      <div className="login-form-side">
        <h2 className="page-title animated-text">
          {text.split("").map((char, index) => (
            <span key={index} style={{ animationDelay: `${index * 0.08}s` }}>
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </h2>

        <div className="login-card">
          <label>Email Address</label>
          <input type="email" placeholder="Enter your email" />

          <label>Password</label>
          <div className="password-box">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
            />
            <span
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="options">
            <span className="forgot">Forgot Password?</span>
          </div>

          <button className="login-btn">Login</button>

          <p className="register">
            Don’t have an account?{" "}
            <span
              onClick={() => navigate("/register")}
              style={{
                cursor: "pointer",
                color: "#ff7a00",
                fontWeight: "bold",
              }}
            >
              Register
            </span>
          </p>

          <p className="go-home" onClick={() => navigate("/")}>
            ← Go to Home Page
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
